// Social network icon exports — sourced from real SVG/PNG assets
import instagram_ from "root/utils/socialNetworks/icons/instagram.svg";
import vkontakte_ from "root/utils/socialNetworks/icons/vkontakte.svg";
import telegram_ from "root/utils/socialNetworks/icons/telegram.svg";
import tiktok_ from "root/utils/socialNetworks/icons/tiktok.svg";
import dzen_ from "root/utils/socialNetworks/icons/dzen.svg";
import youtube_ from "root/utils/socialNetworks/icons/youtube.svg";
import wibes_ from "root/utils/socialNetworks/icons/wibes.svg";

export const instagram = instagram_;
export const instagram_empty = instagram_;
export const vkontakte = vkontakte_;
export const telegram = telegram_;
export const tiktok = tiktok_;
export const dzen = dzen_;
export const youtube = youtube_;
export const wibes = wibes_;

export default {
    instagram,
    instagram_empty,
    vkontakte,
    telegram,
    tiktok,
    dzen,
    youtube,
    wibes,
};
